import http from '@/api/http'

export default {
    getManufacturerList(cb) {
        http.get('/api/calculator/manufacturer/list', cb);
    },
    getMinerListByManufacturerId(cb, request) {
        http.post('/api/calculator/miner/list', cb, request);
    },
    getDifficultyByDate(cb, request) {
        http.post('/api/calculator/difficulty/get', cb, request);
    },
    getPPSByDate(cb, request) {
        http.post('/api/calculator/pps/get', cb, request);
    },
    getEmissionFactorListByYear(cb, request)
    {
        http.post('/api/calculator/emission-factor/list', cb, request);
    },
    calculate(cb, request)
    {
        http.post('/api/calculator/co2/calculate', cb, request);
    }
}